import { createSelector } from 'reselect'
// @ts-ignore
import { SECTION_ACTIVITIES_COMPLETED, FEED_FILTER, FEED_FILTER_TEAMS } from 'app/constants/feed'

import { getIdentityTeams, getIdentityOrganizationTeamOnly } from 'store/entities/identity/selectors'

import { List } from 'immutable'
import { IFeedRecord } from './interface'

export const getFeed = (state: any): IFeedRecord => state.get('feed')

export const getFeedTab = createSelector(getFeed, feed => feed.get('tab'))

export const getFeedRecentList = createSelector(getFeed, feed => feed.get('recent'))

export const getFeedLeaderBoard = createSelector(getFeed, feed => feed.get('leaderBoard'))

export const getFeedLeaderBoardSection = createSelector(getFeedLeaderBoard, feed => feed.get('section'))

export const getFeedFilter = createSelector(getFeed, feed => feed.get('filter'))

export const getFeedFilterByTeam = createSelector(getFeedFilter, filter => filter.get('byTeam'))

export const getFeedFilterByRange = createSelector(getFeedFilter, filter => filter.get('byRange'))

export const getFeedRecentListFilteredByTeam = createSelector(
  [getFeedRecentList, getFeedFilterByTeam, getIdentityTeams, getIdentityOrganizationTeamOnly],
  (list, team, teams, isTeamOnly) => {
    return helperGetListFilteredByTeam(list, team, teams, isTeamOnly)
  }
)

export const getFeedLeaderBoardList = createSelector(getFeedLeaderBoard, leaderBoard => leaderBoard.get('list'))

export const getFeedLeaderBoardByActivitiesCompleted = createSelector(getFeedLeaderBoardList, list => {
  return list.get('byActivitiesCompleted').some(boardItem => !!boardItem.get('completedCount'))
    ? list.get('byActivitiesCompleted')
    : List([])
})

export const getFeedLeaderBoardByStreak = createSelector(getFeedLeaderBoardList, list => {
  return list.get('byStreak').some(boardItem => !!boardItem.get('streakCurrent')) ? list.get('byStreak') : List([])
})

export const getFeedLeaderBoardListBySection = createSelector(
  getFeedLeaderBoardByActivitiesCompleted,
  getFeedLeaderBoardByStreak,
  getFeedLeaderBoardSection,
  (byActivitiesCompleted, byStreak, section) =>
    section === SECTION_ACTIVITIES_COMPLETED ? byActivitiesCompleted : byStreak
)

export const getFeedPending = createSelector(getFeed, feed => feed.get('pending'))

export const getFeedPendingGetLeaderBoard = createSelector(getFeedPending, pending => pending.get('getLeaderBoard'))

export const getFeedPendingGetRecent = createSelector(getFeedPending, pending => pending.get('getRecent'))

export const getFeedRecentPagination = createSelector(getFeed, feed => feed.get('recentPagination'))

export const getFeedPendingGetRecentLoadMore = createSelector(getFeedPending, pending =>
  pending.get('getRecentLoadMore')
)

export const getFeedLoaded = createSelector(getFeed, feed => feed.get('loaded'))

export const getFeedLoadedGetRecent = createSelector(getFeedLoaded, loaded => loaded.get('getRecent'))

export const getFeedLoadedGetRecentLoadMore = createSelector(getFeedLoaded, loaded => loaded.get('getRecentLoadMore'))

export const getLastItemInRecentList = createSelector(getFeedRecentList, list => list.last())

export const getFeedStories = createSelector(getFeed, feed => feed.get('stories'))

export const getFeedStoriesListFilteredByTeam = createSelector(
  [getFeedStories, getFeedFilterByTeam, getIdentityTeams, getIdentityOrganizationTeamOnly],
  (list, team, teams, isTeamOnly) => {
    return helperGetListFilteredByTeam(list, team, teams, isTeamOnly)
  }
)

const helperGetListFilteredByTeam = (list: List<any>, team: any, teams: List<any>, isTeamOnly: boolean) => {
  if (FEED_FILTER === team) {
    if (isTeamOnly) {
      if (teams.size >= 1) {
        return list.filter(item => item.getIn(['user', 'teams'], List([])).some((r: any) => teams.indexOf(r) >= 0))
      } else {
        return list.filter(item => item.getIn(['user', 'teams'], List([])).size === 0)
      }
    }
    return list
  } else {
    if (FEED_FILTER_TEAMS === team) {
      return list.filter(item => item.getIn(['user', 'teams'], List([])).some((r: any) => teams.indexOf(r) >= 0))
    } else {
      return list.filter(item => item.getIn(['user', 'teams'], List([])).includes(team))
    }
  }
}

export const getFeedStoriesPagination = createSelector(getFeed, feed => feed.get('storiesPagination'))

export const getFeedPendingGetStories = createSelector(getFeedPending, pending => pending.get('getStories'))

export const getFeedPendingGetStoriesLoadMore = createSelector(getFeedPending, pending =>
  pending.get('getStoriesLoadMore')
)

export const getFeedLoadedGetStories = createSelector(getFeedLoaded, loaded => loaded.get('getStories'))

export const getFeedLoadedGetStoriesLoadMore = createSelector(getFeedLoaded, loaded => loaded.get('getStoriesLoadMore'))

export const getFeedLastUnreadStoryAuthor = createSelector(getFeed, feed => feed.get('lastUnreadStoryAuthor'))

export const getFeedUnreadStoriesCount = createSelector(getFeed, feed => feed.get('unreadStoriesCount'))
